import React, { useCallback, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import { Typography, withStyles, Button } from '@material-ui/core'
import Api from '../services/Api'
import CircularProgress from '@material-ui/core/CircularProgress'
import CloudUploadIcon from '@material-ui/icons/CloudUpload'
import CloudDoneIcon from '@material-ui/icons/CloudDone'

const styles = theme => ({
  btn: {
    marginRight: theme.spacing(1),
    width: '100%'
  }
})

const enumState = {
  loading: 'loading',
  error: 'error',
  success: 'success',
  default: 'default'
}

const MyDropzone = ({
  input,
  classes,
  accept,
  label,
  solicitacaoId,
  onFileChange,
  showError,
  disabled,
  ...rest
}) => {
  const [state, setState] = useState(enumState.default)

  const onDrop = useCallback(
    async acceptedFiles => {
      const [file] = acceptedFiles
      if (file) {
        setState(enumState.loading)
        const response = await Api.upload(solicitacaoId, file)
        if (response.ok) {
          input.onChange(response.data)
          if (onFileChange) {
            onFileChange(response.data)
          }
          setState(enumState.success)
          return
        }
      }
      setState(enumState.error)
    },
    [input, solicitacaoId, onFileChange]
  )
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept,
    noDrag: true
  })

  return (
    <>
      <div {...getRootProps()}>
        <input {...getInputProps()} {...rest} disabled={disabled} />
        <Button
          variant="outlined"
          color="secondary"
          disabled={state === enumState.loading || disabled}
          className={classes.btn}
          startIcon={
            state === enumState.loading ? (
              <CircularProgress size={24} />
            ) : state === enumState.success ? (
              <CloudDoneIcon />
            ) : (
              <CloudUploadIcon />
            )
          }
        >
          {label || 'Selecionar arquivo'}
        </Button>
        <Typography
          variant="subtitle2"
          component="span"
          color={
            state === enumState.error || showError ? 'error' : 'textPrimary'
          }
        >
          {state === enumState.error && 'Erro no upload do arquivo'}
          {(rest.meta.touched || showError) && rest.meta.error}
        </Typography>
      </div>
    </>
  )
}

export default withStyles(styles)(MyDropzone)
